// extracted by mini-css-extract-plugin
export default {"container":"NHXJdJ","mobileContainer":"zt9IeV","divider":"Cq1ECg"};